import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import ApiCalls from '../../custom-classes/api-calls';
import ListItem from '@material-ui/core/ListItem';
import Select from 'react-select';
import { Media, Col } from 'reactstrap';

class SelectorUserPlanClasses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkedItems: new Map(),
            checkboxes : [],
            checkedValues: props.data.selectedItems,
            itemsIncluded: props.data.itemsIncluded
        };

        if(typeof props !== 'undefined' && typeof props.data !== 'undefined' && typeof props.data.productsUserPlan !== 'undefined')
        {
            this.state = {
                checkedItems: new Map(),
                checkboxes : [],
                checkedValues: props.data.selectedItems,
                itemsIncluded: props.data.itemsIncluded
            };
        }

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Sets the checked items in the first time
     */
    setCheckedItems(){
        for(let i=0; i < this.state.checkedValues.length;i++)
        {
            this.state.checkedItems.set(this.state.checkedValues[i], true);
        }
    }

    /**
     * Mounts the data. Call the data from the server and sets the data to the list
     */
    mountData(){

        if(this.state.itemsIncluded != null && this.state.itemsIncluded.length > 0)
        {
            let options = [];
            // Now fill the selections
            for (let i = 0; i < this.state.itemsIncluded.length; i++)
            {
                options.push({
                    name: this.state.itemsIncluded[i].ItemDescriptionByLang[0].Name,
                    key:   this.state.itemsIncluded[i].Id,
                    label:  this.state.itemsIncluded[i].Id,
                    checked: this.state.checkedValues.indexOf(this.state.itemsIncluded[i].Id) > -1
                })
            }

            this.setState({checkboxes:options});
        }
    }


    /**
     * Action when the component will mount
     */
    componentDidMount(){
        this.mountData();
        this.setCheckedItems();
    }

    /**
     * Removes a value from array
     * @param array
     * @param xToRemove
     * @returns {*}
     */
    removeFromArray(array, xToRemove){
        for(let i = array.length - 1; i >= 0; i--)
        {
            if(array[i] === xToRemove) {
                array.splice(i, 1);
            }
        }
        return array;
    }

    /**
     * Add a value to an array
     * @param array
     * @param xToAdd
     * @returns {*}
     */
    insertInArrayIfNotExists(array, xToAdd){
        if(array.includes(xToAdd))
            return array;
        else {
            array.push(xToAdd);
            return array;
        }

    }

    /**
     * Action when the checkbox changes
     * @param e
     */
    handleChange(e) {
        const isChecked = e.target.checked;
        const value = e.target.value;

        this.setState(prevState => ({checkedItems: prevState.checkedItems.set(value, isChecked) }),()=>{
            let newArray = [];
            if(this.state.checkedItems.get(value)) {
                newArray = this.insertInArrayIfNotExists(this.state.checkedValues, value);
            }
            else {
                newArray = this.removeFromArray(this.state.checkedValues, value);
            }

            this.setState({
                checkedValues: newArray
            },()=>{
                this.props.updateParent(this.state.checkedValues);
                return this.state.checkedValues;
            });
        });
    }

    render() {
        return (
            (this.state.itemsIncluded.length > 0 ?
            <React.Fragment>
                {
                    this.state.checkboxes.map(item => (
                        <ListItem key={item.key} dense button>
                            <Col sm={{size:4}} xs={{size:4}} md={{size:4}} lg={{size:4}}>
                                <Media src={require('../../img/img-lessons.png')} alt="User icon" width="100%"/>
                            </Col>
                            <Col sm={{size:8}} xs={{size:8}} md={{size:8}} lg={{size:8}}>
                            <label key={item.key}>
                                {item.name}
                                <Checkbox name={item.name}
                                          value={item.key}
                                          checked={this.state.checkedItems.get(item.key)}
                                          onChange={this.handleChange} />
                            </label>
                            </Col>
                        </ListItem>
                    ))
                }
            </React.Fragment> : null)
        );
    }
}

export default SelectorUserPlanClasses;


// WEBPACK FOOTER //
// ./src/components/selectors/multi-selector-product-items.js